module.exports = function(store) {
  return store
    ? { storeKey: store.split('/')[0] }
    : {};
};
